import React, { Dispatch, useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

import moment from 'moment';
import classes from './employeeLogs.module.scss';
import { ReactComponent as Exit } from '../../assets/images/exitEmployeeTable.svg';
import { ReactComponent as Arrow } from '../../assets/images/arrowLogs.svg';
import { useHistory } from '../../hooks/entityHooks';
import { RestoreLogDialog } from '../Dialogs/RestoreLogDialog';
import { History } from '../../types/history';

type LogsInfo = {
  id?: number;
  type?: number;
};
type props = {
  setLogs: Dispatch<boolean>;
  logsInfo: LogsInfo;
  handleUpdateEntity(entityId: number, type: number): Promise<void>;
};
type data = {
  date: string;
  middleName: string;
  preview: string;
  result: string;
  owner: string;
};
type fillProps = {
  style: any;
  arr: History[];
  setSectId: Dispatch<number>;
  handleCloseRestoreDialog(): void;
};

const useStyles = makeStyles({
  root: {
    background: 'none',
    borderRadius: 0,
    width: 160,
    color: '#FF7221',
    textTransform: 'none',
    '&:hover, &:focus': {
      background: '#DE6109',
      color: 'white',
    },
    fontFamily: 'HelveticaNeueCyr',
    // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    height: 38,
    fontSize: 14,
    padding: '0 30px',
  },
});

const fillTable = ({
  style,
  arr,
  handleCloseRestoreDialog,
  setSectId,
}: fillProps) => {
  return (
    <>
      {arr.map((el) => {
        const {
          id,
          author,
          entityName,
          field,
          prevValue,
          newValue,
          createdAt,
        } = el;
        const date = moment(createdAt);
        return (
          <tr className={classes.container__table__body__tr}>
            <td>
              <p>{date.format('DD.MM.YYYY')}</p>
            </td>
            <td>{field}</td>
            <td>
              <div className={classes.container__table__body__tr__change}>
                <p>{prevValue}</p> <Arrow />
              </div>

              <div>
                <p>{newValue}</p>
              </div>
            </td>
            <td>
              <p>
                {author.surname} {author.name}
              </p>
            </td>
            <td>
              <Button
                className={style.root}
                onClick={() => {
                  setSectId(id);
                  handleCloseRestoreDialog();
                }}
              >
                Восстановить
              </Button>
            </td>
          </tr>
        );
      })}
    </>
  );
};
export const EmployeeLogs = ({
  setLogs,
  logsInfo,
  handleUpdateEntity,
}: props) => {
  const style = useStyles();
  const [openRestoreDialog, setOpenRestoreDialog] = useState(false);
  const [selectId, setSectId] = useState<number | undefined>();

  const handleCloseRestoreDialog = () => {
    setOpenRestoreDialog(!openRestoreDialog);
  };
  const {
    getEntityList: getHistory,
    entityList: history,
    initLoading,
    changeEntity: restore,
  } = useHistory();

  const { id, type } = logsInfo;
  useEffect(() => {
    const stringParams = `filter[objectId]=${id}&filter[typeObject]=${type}`;
    const search = new URLSearchParams(stringParams);
    getHistory(search);
  }, [id, type]);

  const handleRestore = async (id: number) => {
    await restore(id);
    handleCloseRestoreDialog();
    if (logsInfo && logsInfo.id && logsInfo.type) {
      handleUpdateEntity(logsInfo.id, logsInfo.type);
    }

    const stringParams = `filter[objectId]=${logsInfo.id}&filter[typeObject]=${logsInfo.type}`;
    const search = new URLSearchParams(stringParams);
    getHistory(search);
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.container__title}>
          <p>История действий</p>
          <Exit onClick={() => setLogs(false)} />
        </div>
        <table className={classes.container__table}>
          <thead className={classes.container__table__head}>
            <tr className={classes.container__table__head__tr}>
              <td>Дата</td>
              <td>Поле</td>
              <td>Изменение</td>
              <td>Отредактировано</td>
              <td />
            </tr>
          </thead>
          <tbody className={classes.container__table__body}>
            {fillTable({
              style,
              arr: history,
              setSectId,
              handleCloseRestoreDialog,
            })}
          </tbody>
        </table>
      </div>
      {selectId ? (
        <RestoreLogDialog
          open={openRestoreDialog}
          handleClose={handleCloseRestoreDialog}
          selectId={selectId}
          handleRestore={handleRestore}
          handleUpdateEntity={handleUpdateEntity}
        />
      ) : null}
    </>
  );
};
